<template>
	<modal-container
		ref="modal"
		width="90%"
		maxWidth="1000px"
		@close="close"
		:showX="false"
		:closeByClickOnOverlay="false"
		:closeByClickOnEsc="false"
	>
		<template slot="modal-content">
			<h2
				class="center"
			>
				C'è ancora spazio nella tua box
			</h2>
			<p
				v-if="$mq.isDesktop()"
				class="center"
				v-html="`Ecco i migliori prodotti della settimana, troverai molto altro nel nostro shop sulla pagina successiva`"
			/>

			<keep-alive>
				<SliderQ
					:minSizeOfSlide="200"
					:maxNumSlides='3'
					isCentered
					v-if="!loading"
				>
					<slide v-for="(extra, index) in extras">
						<extra-box
							:key="index"
							:item="extra"
							:order.sync="order"
							:extraParams.sync="extraParams"
							:updating.sync="updating"
							:actionExecuted.sync="actionExecuted"
						>
							<template slot="description" v-if="$mq.isDesktop()">{{ extra.summary }}</template>
						</extra-box>
					</slide>
				</SliderQ>
			</keep-alive>

			<keep-alive>
				<SliderQ
					:minSizeOfSlide="200"
					:maxNumSlides='3'
					isCentered
					v-if="loading"
				>
					<slide
						v-for="i in 3"
					>
						<loading-placeholder
							class="shadow-box"
							:lines="2"
							:lineSize="10"
						/>
					</slide>
				</SliderQ>
			</keep-alive>

			<br>
			<div
				class="flex-center"
			>
				<CTA
					:disabled="updating"
					@click="confirm()"
					:content="$t('components.checkout.continue')"
				/>
			</div>
		</template>
	</modal-container>
</template>

<script>

import { container } from '../../services/container'

import { ExtraApi } from '../../api/ExtraApi'
import { Extras } from '../../core/Extras'

import { orderStore } from '../../store/orderStore'
import { configStore } from '../../store/configStore'
import { deliveryStore } from '../../store/deliveryStore'

import ExtraBox from '../Ecommerce/ExtraBox'

export default {
	data () {
		return {
			extras: [],
			loading: false,

			extraParams: null,
			updating: false,

			actionExecuted: false,

			orderStore: orderStore.state,
			configStore: configStore.state,
			deliveryStore: deliveryStore.state

		}
	},

	components: {
		ExtraBox
	},

	computed: {
		user () {
			return this.$root.user
		},

		shipmentDayEq3 () {
			return this.delivery
				&& this.delivery.shipment_day === 3
		},

		topSkuId () {
			return this.configStore.config && this.configStore.config['quomi.extras.modal_ecommerce']
				? this.configStore.config['quomi.extras.modal_ecommerce']
					.replace(/\s/g, '')
					.split(',')
					.map(r => +r)
				: this.configStore.default.modal_ecommerce
		},

		delivery () {
			return this.deliveryStore
				&& this.deliveryStore.deliveries.order.find(r => r.id === +this.orderStore.order.id)
				&& this.deliveryStore.deliveries.order.find(r => r.id === +this.orderStore.order.id).attributes
		},

		alreadySeen () {
			if (!this.orderStore.order || !this.orderStore.order.id) return false
			return container.get('services.cookies').get('topsku') === this.orderStore.order.id.toString()
		},

		order: {
			get () {
				return this.orderStore.order
			},

			set (newValue) {
				orderStore.state.order = newValue
			}
		}
	},

	methods: {
		close () {
			this.$emit('passToNextStep')
		},

		confirm () {
			if (this.actionExecuted) this.confirmTopSku()
			if (!this.actionExecuted) this.passToEcommerce()
		},

		open () {
			if (!this.alreadySeen && this.topSkuId && this.topSkuId.length > 0) {
				this.loading = true
				this.$refs.modal.open()
				
					return this.loadCurrentDelivery()
				
				.then(response => {
					this.loadAllExtras()
				})
				
			} else {
				this.close()
			}
		},

		passToEcommerce () {
			if (this.topSkuId) container.get('services.cookies').set('topsku', this.orderStore.order.id)
			this.$router.push({
				name: 'verify-page',
				params: {
					referr: this.$mq.isDesktop() ? '' : 'topSku',
					actionExecuted: this.actionExecuted
				} 
			})
		},

		$_extraAction_quantityExtraInOrder (id) {
			if (!this.orderStore.order) return

			var e = this.orderStore.order.getExtraByAttribute('id', id)
			if (e) { return e.quantity }
		},

		removeExtra (params) {
			if (this.shipmentDayEq3) {
				if (!params || !params.id) return
				var index = this.extras.findIndex(r => r.id && r.id === params.id)
				if (index >= 0) {
	 				this.extras.splice(index, 1)
	 			}
			}
		},

		loadAllExtras () {
			this.recipes = []
			var em = new ExtraApi()
			return em.all({
				params: {
					show: 10,
					page: 1,
					sort_direction: 'asc',
					query: 'id in (' + this.topSkuId + ')'
				}
			})

			.then(response => {
				this.extras = new Extras(response.body.data.resources)

				// remove extra with id 2050 (== 'classic breakfast')
				this.removeExtra({ id: 2050 }) 
				if (this.extras.length <= 0) {
					this.close()
					return
				}

				this.sortExtras()
				this.loading = false
			})

			.catch(response => {
				this.close()
			})
		},

		sortExtras () {
			// sort extra by order
			for (var i = this.topSkuId.length - 1; i >= 0; i--) {
				var first = +this.topSkuId[i]
				this.extras.sort((a, b) => a.id === first ? -1 : b.id === first ? 1 : 0)
			}
		},

		confirmTopSku () {
			orderStore.updateOrderParam({ param: 'extra', value: this.extraParams })

				return orderStore.updateOrder()	

			.then(response => {
				var user = this.user
				user.order = this.orderStore.order

				this.$root.updateUser(user)

				this.passToEcommerce()
			})
		},

		loadCurrentDelivery () {
			if (this.user.order) orderStore.state.order = this.user.order
			if (!this.orderStore.order) return Promise.resolve()
			return deliveryStore.getDelivery({ 
	        	target_type: 'order', 
	        	target_id: this.orderStore.order.id
	    	})
		}
	},

	mounted () {
		configStore.loadConfig()
	}
}

</script>

<style scoped>
.btn {
	margin: 0;
	border-radius: 4px;
}

button {
	margin: 0 10px;
}

@media (max-width: 1024px) {
	* >>> .modal-overlay {
		overflow: auto !important;
	}

	* >>> .modal-inner {
		width: 100% !important;
		border: none !important;
		padding: 13px !important;
		border-radius: 0 !important;
	}
}
</style>
